<div [style.background-color]="school?.theme?.primaryColor || '#FFC402'" class="director-section" id="director-desk">
  <div class="wrapper"></div>
  <div class="director-desk">
    <div class="director-wrapper">
      <div class="image">
        <img [src]="school?.principalPic || '../../assets/images/default.jpeg'" alt="Director's photo"
          class="director-photo" />
        <div class="back-layer"></div>
      </div>
      <div class="abt-director">
        <h2 [style.color]="school?.theme?.primaryTextColor || '#000000'">
          {{ school?.principalName }}
        </h2>
        <p [style.color]="school?.theme?.primaryTextColor || '#000000'">
          Principal &#64; {{ school?.name || "Inforida School" }}
        </p>
        <p [style.color]="school?.theme?.primaryTextColor || '#000000'">
          {{ school?.principalEmail }}
        </p>
      </div>
    </div>
    <div class="director-message">
      <h2 [style.color]="school?.theme?.primaryTextColor || '#000000'">
        Principal's Desk,
      </h2>
      <p [style.color]="school?.theme?.primaryTextColor || '#000000'">
        Dear School Community
      </p>
      <p [style.color]="school?.theme?.primaryTextColor || '#000000'">
        {{
        school?.principalMessage ||
        "As we enter session 2024-2025, I want to express my gratitude for the continued dedication and enthusiasm shown
        by our students, staff, and families. This period brings new opportunities and exciting initiatives, and I am
        thrilled about the possibilities ahead. Your collective efforts and support are key to our success, and
        together, we will continue to achieve great things. Thank you for being an integral part of our journey."
        }}
      </p>
      <!-- <p [style.color]="school?.theme?.primaryTextColor || '#000000'">Warm regards,</p> -->
    </div>
  </div>
</div>